module.exports = "/assets/images/a7bd403a80719ac2de3b0baff9842be7.jpg";